import { gql } from '@apollo/client';

export const GET_FEATURE_FLAGS_QUERY = gql`
  {
    featureFlags
  }
`;
